// A build package's activity log (ContentIQ Phase B round 3) — newest first,
// each line "what happened · when · who". The PM's Page build panel and the
// build team's package page both render it, so the two sides read the same
// dates (before 2026-10-22 one showed local time and the other the UTC date,
// a day apart in the evening). Purely presentational.
//
// Props: events [{text, at, by_name}] in the order the backend stores them
// (oldest first); empty (optional) — the line to show when there are none.
import React from 'react';
import { fmtDate } from './ZbSummary';
import { INK } from '../utils/wizardTheme';

export default function CiqPackageEvents({ events, empty = 'Nothing yet.' }) {
  const list = [...(events || [])].reverse();
  return (
    <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {list.map((e, i) => (
        <li key={i} style={{ fontSize: '12.5px', lineHeight: 1.45 }}>
          <div style={{ fontWeight: 600, color: INK.primary }}>{e.text}</div>
          <div style={{ fontSize: '11.5px', color: INK.secondary }}>
            {e.at ? fmtDate(e.at) : ''}
            {e.by_name ? ` · ${e.by_name}` : ''}
          </div>
        </li>
      ))}
      {list.length === 0 && <li style={{ fontSize: '12.5px', color: INK.secondary }}>{empty}</li>}
    </ol>
  );
}
